/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2016 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
var dependencies = ['ngMaterial', 'ngCookies', 'ui.router', 'comcast-addelivery-constants', 'comcast.common.authentication', 'comcast.common.notification', 'comcast.common.communication'];
var defaultName = angular.module('comcast.login', dependencies).config(['$stateProvider', 'EndPointServiceProvider', 'addelivery.state.constants', function ($stateProvider, EndPointServiceProvider, stateConstants) {
  $stateProvider.state('login', {
    url: '/login',
    // Have to assign a params object to prevent excess params being filtered off by ui-router
    params: {
      successMsg: null,
      // You can optionally specify a default value here
      errorMsg: null
    },
    views: {
      mainNav: stateConstants.loginNav,
      content: {
        template: require('./login-template.html'),
        controller: 'LoginController',
        controllerAs: 'vm'
      }
    }
  }).state('resetPassword', {
    url: '/reset',
    views: {
      mainNav: stateConstants.loginNav,
      content: {
        template: require('./reset-template.html'),
        controller: 'ResetController',
        controllerAs: 'vm'
      }
    }
  }).state('eula', {
    url: '',
    views: {
      mainNav: stateConstants.mainNav,
      content: {
        template: require('./eula-template.html'),
        controller: 'EulaController',
        controllerAs: 'vm'
      }
    }
  }).state('eula.doc', {
    url: '/eula',
    views: {
      'doc@eula': {
        // Directly reference the endpoint for eula, which retrieves it from CWE
        templateUrl: EndPointServiceProvider.$get().getApiUrl() + '/page/eula'
      }
    }
  }).state('registerUser', {
    url: '/register',
    views: {
      mainNav: stateConstants.loginNav,
      content: {
        template: require('./register-template.html'),
        controller: 'RegisterController',
        controllerAs: 'vm'
      }
    }
  }).state('browserSupport', {
    url: '/browser',
    views: {
      mainNav: stateConstants.loginNav,
      content: {
        template: require('./browser-template.html'),
        controller: 'BrowserSupportController',
        controllerAs: 'vm'
      }
    }
  });
}]).name;
export { defaultName as default, dependencies };